import {convertToInt} from '@utils/helpers';

export function prepareFailoversForDropdown(data, udpOriginEntryPointId) {
    return data.filter((item) => {
        return convertToInt(item.id) !== udpOriginEntryPointId;
    });
}
